import type { FC, PropsWithChildren } from 'react';
import getThemeColor from '../../utils/getThemeColor';
import { colors } from '../../css-library/tokens/reference';
import { IPrismicLink, PrismicLinkContext } from '@monofront/types';
import { PrismicLink } from '../../prismic-link/PrismicLink';
import { HORIZONTAL_BANNER_SIZE } from './types';

type HorizontalBannerCommonProps = {
  trackingId?: string;
  attributeTitle?: string;
  backgroundColor?: string;
  UNSAFE_className?: string;
  size?: HORIZONTAL_BANNER_SIZE;
};

type HorizontalBannerProps = HorizontalBannerCommonProps &
  (
    | {
        link: IPrismicLink;
        linkingContext: PrismicLinkContext;
        onClick?: undefined;
      }
    | {
        link?: undefined;
        linkingContext?: undefined;
        onClick: () => void;
      }
  );

const HorizontalBanner: FC<PropsWithChildren<HorizontalBannerProps>> = ({
  children,
  link,
  linkingContext,
  trackingId,
  attributeTitle,
  onClick,
  backgroundColor: backgroundColorInput,
  size = HORIZONTAL_BANNER_SIZE.RESPONSIVE,
  UNSAFE_className,
}) => {
  const backgroundColor = backgroundColorInput
    ? getThemeColor(backgroundColorInput)
    : colors.yellow[100];
  const isResponsive = size === HORIZONTAL_BANNER_SIZE.RESPONSIVE;
  const className = `${UNSAFE_className} tw-items-center tw-gap-2 ${
    isResponsive ? 'desktop:tw-gap-4' : ''
  } tw-flex tw-flex-row tw-group tw-w-full tw-justify-between tw-rounded-2xl tw-px-3 tw-py-4 hover:tw-cursor-pointer ${
    isResponsive ? 'desktop:tw-px-8' : ''
  }`;

  if (link?.link_type !== 'Any' && linkingContext) {
    return (
      <PrismicLink
        link={link}
        trackingId={trackingId}
        className={`${className}`}
        style={{ backgroundColor }}
        context={linkingContext}
      >
        {children}
      </PrismicLink>
    );
  }
  if (onClick) {
    return (
      <button
        onClick={onClick}
        title={attributeTitle || ''}
        className={`tw-lf-button-clear ${className}`}
        style={{ backgroundColor }}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={className} style={{ backgroundColor }}>
      {children}
    </div>
  );
};

export default HorizontalBanner;
